import { String, Number, Object, Intersect, Static, Optional } from '@sinclair/typebox';

const BaseFare = Object({
  bookingClass: String(),
  segmentId: String(),
  avlSeats: Number(),
});

export type Fare = Static<typeof Fare>;
export const Fare = Intersect([
  BaseFare,
  Object({
    fareClass: Optional(String()),
    cabinClass: Optional(String()),
  }),
]);
